import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from 'src/app/core/store/store';
import { CourseService } from 'src/app/shared/services/course.service';
// import { CourseService } from 'src/app/services/course.service';
// import { Store } from 'store';
@Component({
  selector: 'app-primer-completion',
  templateUrl: './primer-completion.component.html',
  styleUrls: ['./primer-completion.component.css']
})
export class PrimerCompletionComponent implements OnInit {

  @Input() nextItemId;
  @Input() exerciseData;
  @Input() courseName;
  @Input() courseId;
  @Input() exerciseDetails;
  @Input() exerciseId
  @Input() totalPoints;
  @Input() totalExPoints;
  @Input() evaluationResult
  @Input() exerciseRows;
  @Input() attemptedExercise;
  enableCustomiseMessaging: boolean = false;

  ParameterThresholdmessages = {
    SKILL: `An ability we gain through practice and training.`,
    EFFORT: `A determined attempt towards a particular goal.`,
    CONFIDENCE: `The degree to which you think your actions will achieve positive results.`
  }
  isNew = false;
  initialized = false;
  course;

  newInsights = {
    message1: '',
    message2: '',
    thresholdAchieved: '',
    thresholdNotAchieved: '',
    growthArea: [],
    strength: []
  };

  count = {
    videos: 0,
    assessments: 0,
    practicalQuestions: 0
  }

  xData = {
    SKILL: 0,
    EFFORT: 0,
    CONFIDENCE: 0
  }
  user: any;

  constructor(private courseService: CourseService, private store: Store) { }

  ngOnInit() {
    console.log(this.exerciseData);
    console.log(this.attemptedExercise);
    this.store.select('user').subscribe((user:any) => {
          this.user = user;
    });
    this.store.select('course').subscribe(course => {
      this.course = course;
      this.countContent();
      console.log(this.course);
      this.enableCustomiseMessaging = this.course.enableCustomiseMessaging;
    });
    if (this.attemptedExercise && this.attemptedExercise.areaLevelScored && this.attemptedExercise.areaLevelScored.length > 0
      && this.exerciseData.messagingAndThresholdInfo && (this.exerciseData.messagingAndThresholdInfo.length > 0)) {
      this.isNew = false;
      this.getNewInsights();
    }
    this.initialized = true;
  }

  countContent() {
    this.count = {
      videos: 0,
      assessments: 0,
      practicalQuestions: 0
    }
    this.course.contents.forEach(content => {
      if (content.contentInfo.mediaType == 'VIDEO') {
        this.count.videos += 1;
      } else if (content.contentInfo.mediaType == 'HTML') {
        this.count.assessments += 1;
      }
    });
  }

  getNewInsights() {
    this.isNew = true;
    let userPercentageScored = 0;
    if (this.totalExPoints) {
      userPercentageScored = (this.totalPoints / this.totalExPoints) * 100;
    }
    let hasMessages = false;
    this.exerciseData.messagingAndThresholdInfo.forEach(el => {
      if (userPercentageScored <= el.max && userPercentageScored >= el.min) {
        this.newInsights.message1 = el.message1;
        this.newInsights.message2 = el.message2;
        hasMessages = true;
      }
    });
    if (!hasMessages) {
      this.isNew = false;
    }

    this.attemptedExercise.areaLevelScored.forEach((area, index) => {
      if (this.ParameterThresholdmessages[area.areaName]) {
        if (area.percentage > area.threshold) {
          this.newInsights.strength.push(area.areaName);
        } else {
          this.newInsights.growthArea.push(area.areaName);
        }
        this.xData[area.areaName] = area.percentage;
        if (area.areaName.length > 1) {
          area.areaName = area.areaName.slice(0, 1) + area.areaName.slice(1).toLowerCase();
        }
        console.log(this.xData);
      }
    });
    this.createMessages();

  }

  createMessages() {
    let strengthCount = this.newInsights.strength.length;
    let growthCount = this.newInsights.growthArea.length;
    this.getMessages(strengthCount, 1);
    this.getMessages(growthCount, 2);
  }

  getMessages(count, type) {
    let msgKey = 'thresholdAchieved';
    let paraKey = 'strength';
    let msgKey1 = 'strength';
    if (type == 2) {
      msgKey = 'thresholdNotAchieved';
      paraKey = 'growthArea';
      msgKey1 = 'growth area'
    }
    switch (count) {
      case 1:
        this.newInsights[msgKey] = `Your ${msgKey1} is ${this.getCamel(this.newInsights[`${paraKey}`][0])}.`;
        break;

      case 2:
        this.newInsights[msgKey] = `Your ${msgKey1}s are ${this.getCamel(this.newInsights[`${paraKey}`][0])} and ${this.getCamel(this.newInsights[`${paraKey}`][1])}.`;
        break;

      case 3:
        this.newInsights[msgKey] = `Your ${msgKey1}s are ${this.getCamel(this.newInsights[`${paraKey}`][0])}, ${this.getCamel(this.newInsights[`${paraKey}`][1])} and ${this.getCamel(this.newInsights[`${paraKey}`][2])}.`;
        break;
    }

  }


  getCamel(str) {
    return str.slice(0, 1) + str.slice(1).toLowerCase();
  }

  next() {
    this.courseService.setcurrentPlayedItem(this.nextItemId)
  }

}
